import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
// components

import CardLineChart from "components/Cards/CardLineChart.js";
import CardBarChart from "components/Cards/CardBarChart.js";
import ColumnChart from "components/Cards/ColumnChart";
import MonthColumnchart from "components/Cards/MonthColumnchart";
import CardStats from "components/Cards/CardStats";
import HeaderStats from "components/Headers/HeaderStats";
import ExpensesTypewisetable from "components/Cards/ExpensesTypewisetable";
import UserMessageCountsChart from "components/CardsForMarketing/UserMessageCountsChart";
import ExpanseTypeWiseLineChart from "components/Cards/ExpanseTypeWiseLineChart";
import BASE_URL from "components/BaseUrl/apiConfig";

export default function Dashboard() {
  const history = useHistory();

  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  //get userid form loca storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let userTypeId = "";
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    userTypeId = userData.userTypeId;
  }

  //section permission
  const [mainUser, setMainUser] = React.useState([]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/GetUserById?userId=${userId}`
        );
        if (response.ok) {
          const data = await response.json();
          setMainUser(data);
        } else {
          console.error("Failed to fetch user data:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching user data:", error.message);
      }
    };
    fetchUserData();
  }, [userId]);

  const [showMessage, setShowMessage] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (
        !mainUser.chkDashboard &&
        !mainUser.chkDocuments &&
        !mainUser.chkExpense &&
        !mainUser.chkMarketing &&
        !mainUser.chkNotes &&
        !mainUser.chkQuantityTracker &&
        // !mainUser.chkLocations &&
        userTypeId !== 2
      ) {
        setShowMessage(true);
      } else {
        setShowMessage(false);
      }
    }, 500); // 0.5-second delay

    // Cleanup function to clear the timeout if dependencies change
    return () => clearTimeout(timer);
  }, [mainUser, userTypeId]);

  return (
    <>
      <Navbar />
      <div className="min-h-content-minvh">
        {/* <div className="flex flex-wrap mb-3">
        <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
          <HeaderStats/>
        </div>
      </div> 
       <div className="flex flex-wrap">
            <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
              <CardLineChart />
            </div>
            <div className="w-full xl:w-4/12 px-4">
              <CardBarChart />
            </div>
          </div>
          <div className="flex flex-wrap mt-4">
            <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
              <ColumnChart />
            </div>
            <div className="w-full xl:w-4/12 px-4">
              <MonthColumnchart />
            </div>  
          </div> */}
        {/* <div className="flex flex-wrap mt-3">
            <div className="w-full xl:w-12/12 xl:mb-0 px-3">
              <ExpanseTypeWiseLineChart />
            </div>
            
          </div> */}
        <HeaderStats />

        {(mainUser.chkExpense || userTypeId === 2) && (
          <div className="flex flex-wrap mt-3">
            <div className="w-full xl:w-12/12 xl:mb-0 px-3">
              <ExpensesTypewisetable />
            </div>
          </div>
        )}
        {(mainUser.chkMarketing || userTypeId === 2) && (
          <div className="flex flex-wrap mt-3">
            <div className="w-full xl:w-12/12 mb-12 xl:mb-0 px-3">
              <UserMessageCountsChart />
            </div>
          </div>
        )}

        {showMessage && (
          <div className="w-50 mx-auto">
            <h2>
              You don't have permission to view this content. Please contact
              your administrator for assistance.
            </h2>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
}
